import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getDetailMonsterSuccess,
  getDetailMonsterFailed,
  GET_DETAIL_MONSTER_START,
} from '../../actions/monster'

/**
 * get detail monster
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getDetailMonsterApi = (props) => {
  var uri = `/monsters/${props}`
  return api.get(uri)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDetailMonster(action) {
  try {
    const response = yield call(getDetailMonsterApi, action?.payload)
    yield put(getDetailMonsterSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getDetailMonsterFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get detail monster
 */
export default function* watchGetDetailMonster() {
  yield takeLatest(GET_DETAIL_MONSTER_START, doGetDetailMonster)
}
